export default {
  hero: {
    badge: 'Centrum zasobów USFans Spreadsheet',
    title: 'USFans Spreadsheet — Znajdź produkty, sprzedawców i poradniki zakupowe',
    subtitle: 'Poznaj zasoby arkusza USFans, linki do produktów, informacje o sprzedawcach, recenzje, poradniki wysyłki, wskazówki QC i praktyczne informacje zakupowe w jednym uporządkowanym miejscu.',
    ctaExplore: 'Odkryj USFans Spreadsheet',
    ctaBuy: 'Kup teraz',
  },
  category: {
    title: 'Przeglądaj kategorie produktów',
    subtitle: 'Przejdź bezpośrednio do dowolnej kategorii na głównej stronie jednym kliknięciem.',
    dropdownLabel: 'Szybki wybór kategorii',
    dropdownPlaceholder: 'Wybierz kategorię...',
    visit: 'Zobacz kategorię',
    shoes: 'Buty',
    hoodies: 'Bluzy / Swetry',
    tshirts: 'Koszulki',
    jackets: 'Kurtki',
    pants: 'Spodnie / Szorty',
    headwear: 'Nakrycia głowy',
    sets: 'Zestawy',
    underwear: 'Bielizna / Majtki',
    jersey: 'Koszulki sportowe',
    accessories: 'Akcesoria',
    bags: 'Torby',
    belts: 'Paski',
    perfumes: 'Perfumy',
    other: 'Inne rzeczy',
  },
  cta: {
    title: 'Zacznij od USFans Spreadsheet',
    text: 'Poznaj uporządkowane zasoby USFans, recenzje, informacje o wysyłce i praktyczne poradniki zakupowe. Dwa szybkie linki przeniosą Cię prosto na główną stronę.',
    spread: 'USFans Spreadsheet',
    buyNow: 'Kup teraz',
  },
  about: {
    title: 'Czym jest USFans Spreadsheet?',
    p1: 'Arkusz USFans to uporządkowany sposób organizowania linków do produktów, informacji o sprzedawcach, kategorii i powiązanych zasobów zakupowych w jednym, przejrzystym miejscu.',
    p2: 'USFansLink pomaga użytkownikom wyszukiwać produkty, sprzedawców, kontrolę jakości, wysyłkę, informacje o magazynie i kwestie bezpieczeństwa przed złożeniem zamówienia. Łączy najbardziej przydatne zasoby, dzięki czemu szybciej znajdziesz to, czego potrzebujesz.',
  },
  resources: {
    title: 'Popularne zasoby',
    subtitle: 'Szybkie odpowiedzi na pytania, które kupujący zadają najczęściej przed zamówieniem.',
    reviews: { title: 'Recenzje USFans', text: 'Dowiedz się, co sprawdzić przed skorzystaniem z usługi lub sprzedawcy.' },
    shipping: { title: 'Koszt wysyłki USFans', text: 'Poznaj, co może wpływać na koszty wysyłki i czas dostawy.' },
    coupons: { title: 'Kupony USFans', text: 'Dowiedz się, jak znaleźć i zweryfikować dostępne kupony i kody rabatowe.' },
    warehouse: { title: 'Magazyn USFans', text: 'Zrozum magazynowanie, inspekcję i powiązane procesy.' },
    legit: { title: 'Czy USFans jest legalne?', text: 'Poznaj praktyczne kontrole bezpieczeństwa przed zakupem.' },
  },
  guide: {
    title: 'Nowy w USFans? Zacznij tutaj',
    text: 'Przeczytaj nasz kompletny przewodnik dla początkujących, aby zrozumieć arkusz, co sprawdzić przed zamówieniem i jak uniknąć typowych błędów.',
    cta: 'Przeczytaj pełny przewodnik',
  },
  pillar: {
    title: 'Artykuły i poradniki',
    subtitle: 'Szczegółowe poradniki obejmujące tematy, które mają największe znaczenie przed zamówieniem.',
  },
  faq: {
    title: 'Często zadawane pytania',
    q1: 'Czym jest arkusz USFans?',
    a1: 'Arkusz USFans to uporządkowany katalog linków do produktów, kategorii, danych sprzedawców i zasobów zakupowych. Pomaga przeglądać i porównywać produkty w jednym miejscu.',
    q2: 'Jak kupić produkt znaleziony w arkuszu?',
    a2: 'Kliknij link kategorii, aby przejść na główną stronę, znajdź interesujący Cię produkt i dokończ standardowy proces zakupu.',
    q3: 'Czy informacje w arkuszu są zawsze aktualne?',
    a3: 'USFansLink utrzymuje strukturę i linki w porządku, ale dostępność i ceny produktów są zarządzane przez główną stronę. Zawsze sprawdzaj tam szczegóły przed zamówieniem.',
    q4: 'Czy USFansLink to to samo co główna strona?',
    a4: 'Nie. USFansLink to niezależne źródło informacji, które pomaga odkrywać i rozumieć arkusz. Zakupy odbywają się na głównej stronie.',
  },
};